import React from 'react'
import { FaWhatsapp } from 'react-icons/fa'
import { FiPhoneCall } from 'react-icons/fi'
import { MdLocationPin, MdOutlinePhoneCallback } from 'react-icons/md'
import { TiMail } from 'react-icons/ti'
import { Link } from 'react-router-dom'

const Contact = () => {
    document.title = 'MACRUM | Contact Us'
    document.querySelector('meta[rel="canonical"]').setAttribute('href', 'https://macrum.in/contact')

  return (
    <>
        <div className='pt-28'>
            <div className='w-fit grid grid-cols-2 md:grid-flow-col items-center gap-y-4 gap-x-4 mx-auto'>
                <div className='flex-center border w-40 h-28 bg-blue-950 border-blue-800 rounded-md'>
                    <div>
                        <Link to='mailto:info@macrum.in'>
                            <TiMail className='text-5xl mx-auto' />
                            <p className='text-2xl font-semibold'>Mail</p>
                        </Link>
                    </div>
                </div>
                <div className='flex-center border w-40 h-28 bg-blue-950 border-blue-800 rounded-md'>
                    <div>
                        <Link to='tel:+91 8900689991'>
                            <FiPhoneCall className='text-5xl mx-auto' />
                            <p className='text-2xl font-semibold'>Call Us</p>
                        </Link>
                    </div>
                </div>
                <div className='flex-center border w-40 h-28 bg-blue-950 border-blue-800 rounded-md'>
                    <div>
                        <Link to=''>
                            <MdOutlinePhoneCallback className='text-5xl mx-auto' />
                            <p className='text-2xl font-semibold'>Call Back</p>
                        </Link>
                    </div>
                </div>
                <div className='flex-center border w-40 h-28 bg-blue-950 border-blue-800 rounded-md'>
                    <div>
                        <Link to='https://wa.me/+918900689991?text=Hi'>
                            <FaWhatsapp className='text-5xl mx-auto' />
                            <p className='text-2xl font-semibold'>WhatsApp</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
        
        <div className='w-fit px-4 lg:px-16 py-4 mt-4'>
            <div className='px-12 lg:px-14 py-4 border-2 bg-blue-950 border-blue-800 rounded-xl'>
                <div className='flex text-2xl font-semibold items-center'>
                    <MdLocationPin className='text-slate-200' />
                    <h4 className='text-slate-200'>Office</h4>
                </div>
                <p className='text-slate-400 px-6 py-1'>Dankuni, Hooghly, <br /> West Bengal - 712311, India</p>
            </div>
        </div>
    </>
  )
}

export default Contact
